import * as ga4 from './providers/ga4'
import * as mixpanel from './providers/mixpanel'

export function track(eventName: string, props: Record<string, unknown> = {}) {
  try {
    const win = window as any
    const provider = (win.PACTA_ANALYTICS_PROVIDER || '').toLowerCase() || 'auto'

    if (provider === 'ga4') {
      return ga4.track(eventName, props)
    }
    if (provider === 'mixpanel') {
      return mixpanel.track(eventName, props)
    }

    // auto: prefer GA4 then mixpanel
    if (typeof win.gtag === 'function') {
      ga4.track(eventName, props)
      return
    }

    if (win.mixpanel && typeof win.mixpanel.track === 'function') {
      mixpanel.track(eventName, props)
      return
    }

    // fallback to console — make logs user-friendly
    try {
      const verbose = !!(win.PACTA_ANALYTICS_VERBOSE || false)
      // eslint-disable-next-line no-console
      console.groupCollapsed(`[analytics][fallback] ${eventName} — ${new Date().toISOString()}`)
      // eslint-disable-next-line no-console
      console.info('event:', eventName)
      // eslint-disable-next-line no-console
      console.info('props:', props)
      if (verbose) {
        // eslint-disable-next-line no-console
        console.trace('analytics trace')
      }
      // eslint-disable-next-line no-console
      console.groupEnd()
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log('analytics:event', { name: eventName, props })
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('analytics.track error', err)
  }
}

export default { track }
